import { Adapter } from './adapter';
import { Maintenance } from '@app/models/maintenance.model';
import { MaintenanceInterface } from '../interfaces/_index';

/**
 * Adapt raw maintenance CMS object to Maintenance model
 * NOTE: The item fields are the default json property names.
 */
export class MaintenanceAdapter implements Adapter<Maintenance> {
  /**
   * Adapt data item into a Maintenance model.
   * @param item - data item Maintenance Interface to be transformed
   * @returns - returns an adapted Maintenance model
   */
  adapt(item: MaintenanceInterface): Maintenance {
    let maintenance: Maintenance;
    if (item) {
      maintenance = new Maintenance(
        item.content.rendered,
        item.modified,
        item.acf.display_notification,
        item.acf.enable_downtime
      );
    }
    return maintenance;
  }
}
